export default () => jQuery(($) => {
    $('.randomize').each(function(){
        const items = $(this).children('.randomize__item');
        const index = parseInt((Math.random() * (items.length)), 10);
        items.hide().eq(index).show();
    });
});
